module.exports = function getResource(label, vars = []) {
    let resources = {
        tierCelebrationGift: 'Tier Celebration Gift'
    };

    return resources[label];
};
